/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useRef } from 'react';
import useLearningContents from '@/context/contents/hook';
import { contentsService } from '@/services/contents';
import { Content } from '@/services/contents/content.vm';

const useContentInteractionWatcher = ({
  content,
  userRouteProgressId,
  routeId,
}: {
  content?: Content;
  routeId?: string;
  userRouteProgressId?: string;
}) => {
  const { updateLearningContent, updateStageContent } = useLearningContents();
  const interactionsRef = useRef<{ [key: string]: boolean }>({});

  useEffect(() => {
    if (!content?.id || !routeId || !userRouteProgressId) return;
    if (interactionsRef.current[content?.id]) return;

    // update content interaction to track visits
    const service = contentsService.updateContentInteraction(content.contentInteractionId, {
      lastVisitedAt: new Date().toISOString(),
      visitCount: (content.visitCount ?? 0) + 1,
    });

    service.then((response) => {
      const { lastVisitedAt, visitCount, id } = response;
      if (!content.stageId) {
        updateLearningContent(routeId, content?.id, { lastVisitedAt, visitCount, contentInteractionId: id });
      } else {
        updateStageContent(routeId, content?.stageId, content?.id, {
          lastVisitedAt,
          visitCount,
          contentInteractionId: id,
        });
      }
    });
    interactionsRef.current[content?.id] = true;
  }, [routeId, content, userRouteProgressId]);
};

export default useContentInteractionWatcher;
